<template>
  <v-container
    id="usermanagement-roles"
    fluid
    tag="section"
  >
    <base-material-card
      inline
      icon="mdi-currency-usd"
      :title="`${$t('sidebar.billing').toUpperCase()}`"
      class="px-5 py-3"
    >
      <v-col
        cols="12"
        sm="12"
      >
        <v-text-field
          v-model="submit"
          full-width
          :label="$t('search')"
          @keyup.enter="search"
        />
      </v-col>

      <v-client-table
        v-if="tableData.length"
        ref="table"
        :data="tableData"
        :columns="table.columns"
        :options="table.options"
      >
        <!--  Action-->
        <template
          slot="action"
          slot-scope="props"
        >
          <!--  Edit-->
          <v-btn
            v-if="showEditFacture(props.row.type, props.row.paiementId, props.row.lot)"
            fab
            dark
            x-small
            color="success"
            @click="editView(props.row.id, props.row.type, true)"
          >
            <v-icon dark>
              mdi-pencil
            </v-icon>
          </v-btn>

          <!--  View-->
          <v-btn
            class="ml-2"
            fab
            light
            x-small
            color="white"
            @click="editView(props.row.id, props.row.type, false)"
          >
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>

          <!--  Refund-->
          <!-- Stripe, payfacto -->
          <!-- On désactive si pas de paiementId -->
          <v-btn
            v-if="parameterFournisseurPaiement === 'stripe' || parameterFournisseurPaiement === 'payfacto'"
            :disabled="Boolean(!props.row.paiementId) || disabledPaymentStatus(props.row.paiement_statut)"
            class="ml-2"
            fab
            light
            x-small
            :title="$t('Refund')"
            color="green"
            @click="getRefund(props.row.id)"
          >
            <v-icon>mdi-credit-card-refund</v-icon>
          </v-btn>
        </template>

        <!--  Type-->
        <template
          slot="type"
          slot-scope="props"
        >
          <!-- Mode de paiment-->
          <!-- Payable par code de facturation( UBR)-->
          <template v-if="props.row.type === 1">
            <v-tooltip
              top
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  color="green"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-book-open-variant
                </v-icon>
              </template>
              <span>UBR</span>
            </v-tooltip>
          </template>

          <!-- Carte de crédit-->
          <template v-if="props.row.type === 2">
            <v-tooltip
              top
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  large
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-credit-card
                </v-icon>
              </template>
              <span>{{ $t('order.Credit_card') }}</span>
            </v-tooltip>
            <template v-if="props.row.InscriptionPaiementId">
              <span>[{{ props.row.InscriptionPaiementId }}]</span>
            </template>
          </template>
        </template>

        <!--  Numéro de contrat-->
        <template
          slot="Contrat.no"
          slot-scope="props"
        >
          <span>{{ props.row.Contrat.no | phoneNumberFormat }} [ {{ props.row.Contrat.id }} ]</span>
        </template>

        <!--  Paiement status-->
        <template
          slot="paiement_statut"
          slot-scope="props"
        >
          <!-- Carte de crédit seulement -->
          <v-btn
            v-if="props.row.type === 2"
            :disabled="!props.row.paiement_statut"
            :color="getTransactionColor(props.row.paiement_statut)"
            class="ma-2 white--text"
            small
            @click="getListTransactions(props.row.id)"
          >
            {{ props.row.paiement_statut ? $t(`Payment.transaction_status.${props.row.paiement_statut}`) : $t('Payment.No_transaction') }}
            <v-icon
              right
              dark
            >
              {{ getTransactionIcon(props.row.paiement_statut) }}
            </v-icon>
          </v-btn>
        </template>

        <!--  Cancel-->
        <template
          slot="cancel"
          slot-scope="props"
        >
          <span
            v-if="props.row.statut === -1"
            class="red--text"
          >
            {{ $t('contract.bill.Cancel') }}
          </span>

          <!--  Si pas annulé-->
          <v-btn
            v-else
            fab
            dark
            x-small
            color="red"
            :title="$t('Cancel')"
            @click="cancel(props.row.id)"
          >
            <v-icon dark>
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-client-table>
    </base-material-card>

    <!-- Édition -->
    <v-dialog
      v-model="dialogEdit"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          :color="typeEdit === 1 ? 'green' : 'primary'"
        >
          <v-btn
            icon
            dark
            @click="dialogEdit = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon
                  large
                >
                  {{ typeEdit === 1 ? 'mdi-book-open-variant' : 'mdi-credit-card' }}
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  <h3>{{ $t('Billing_detail') }} {{ factureId }}</h3>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <facture-mensuelle-edit
          ref="factureMensuelleEdit"
          :edit="edit"
          :type-edit="typeEdit"
          @close-dialog="closeDialog"
        />
      </v-card>
    </v-dialog>

    <!-- Remboursement -->
    <v-dialog
      v-model="dialogRefund"
      max-width="800px"
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogRefund = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon
                  large
                >
                  mdi-credit-card-refund
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  <h3>{{ $t('Refund') }} ID: {{ factureId }}</h3>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <facture-refund-dialog
          ref="factureRefundDialog"
          @close-dialog="closeDialog"
        />
      </v-card>
    </v-dialog>

    <!-- Transactions sur la facture -->
    <v-dialog
      v-model="dialogPaiementList"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogPaiementList = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon
                  large
                >
                  mdi-credit-card
                </v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  <h3>{{ $t('Payment.Transactions_list') }} {{ factureId }}</h3>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <payments-list-stripe-component
          ref="paymentsListStripeComponent"
          :data-transactions="dataTransactions"
          :per-page="25"
          @update-list-transactions="updateListTransactions"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  // Component
  import FactureMensuelleEdit from '@/components/Client/Facture/FactureMensuelleEdit'
  import FactureRefundDialog from '@/components/Client/Facture/FactureRefundDialog'
  import PaymentsListStripeComponent from '@/components/Payments/Stripe/PaymentsListComponent'
  // Service
  import FacturesService from '@/services/01Cell/FacturesService'
  import StripeChargeService from '@/services/STRIPE/StripeChargeService'
  // Mixins
  import { Payment } from '@/mixins/Payment/Payment'
  // Other
  import {
  } from 'vee-validate'
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OperationClientFacture',
    components: {
      FactureMensuelleEdit,
      FactureRefundDialog,
      PaymentsListStripeComponent,
    },
    mixins: [Payment],
    data () {
      return {
        submit: '',
        dialogEdit: false,
        edit: false,
        typeEdit: null,
        factureId: null,
        tableData: [],
        table: {
          columns: [],
          options: {
            sortable: [],
            filterByColumn: false,
            filterable: [],
            pagination: { chunk: 5 },
            perPage: 25,
            perPageValues: [10, 25, 50, 100],
            showChildRowToggler: false, // Si il y a des child row, sert pour cacher la colonne + pour afficher le child row. On utilise la fonction 'tableRowClick' plus bas
            texts: {
              count: this.$i18n.t('vueTables.texts.Showing') + ' {from} ' + this.$i18n.t('vueTables.texts.to') + ' {to} ' + this.$i18n.t('vueTables.texts.of') + ' {count} ' + this.$i18n.t('vueTables.texts.Records').toLowerCase() + '|{count} ' + this.$i18n.t('vueTables.texts.Records').toLowerCase() + '|' + this.$i18n.t('vueTables.texts.One_record'),
              first: this.$i18n.t('vueTables.texts.First'),
              last: this.$i18n.t('vueTables.texts.Last'),
              filter: this.$i18n.t('vueTables.texts.Filter') + ':',
              filterPlaceholder: this.$i18n.t('vueTables.texts.Search_query'),
              limit: this.$i18n.t('vueTables.texts.Records'),
              page: 'Page:',
              noResults: this.$i18n.t('vueTables.texts.No_matching_records'),
              filterBy: this.$i18n.t('vueTables.texts.Filter_by') + ' {column}',
              loading: this.$i18n.t('vueTables.texts.Loading'),
              defaultOption: this.$i18n.t('vueTables.texts.Select') + ' {column}',
              columns: this.$i18n.t('vueTables.texts.Columns'),
            },
            headings: {
              'Contrat.no': this.$i18n.t('Contract'),
              'Client.displayName': 'Client',
              montant_total: 'Total',
              paiement_statut: 'Transaction',
              cancel: this.$i18n.t('Cancel'),
            },
            columnsClasses: {
              action: 'VueTables-width-action-column text-left', // Voir dans le fichier 'style.scss'
              cancel: 'VueTables-width-action-column text-center', // Voir dans le fichier 'style.scss'
            },
            sortIcon: {
              is: 'fa-sort',
              base: 'fas',
              up: 'fa-sort-up',
              down: 'fa-sort-down',
            },
          },
        },
        dialogRefund: false,
        dialogPaiementList: false,
        dataTransactions: {
          data: [],
          has_more: false,
          next_page: null,
        },
      }
    },

    computed: {
      ...mapGetters('parameters', {
        parameterFournisseurPaiement: 'getFournisseurPaiement',
      }),
    },

    mounted () {
      this.table.columns = ['action', 'id', 'periode', 'type', 'Client.displayName', 'Contrat.no', 'montant_total', 'frais_ajustement', 'cancel']
      this.table.options.sortable = ['id', 'periode', 'type', 'Client.displayName', 'Contrat.no', 'montant_total']
      this.table.options.filterable = ['id', 'periode', 'type', 'Client.displayName', 'Contrat.no', 'montant_total']
      if (this.parameterFournisseurPaiement === 'stripe') {
        this.table.columns = ['action', 'id', 'periode', 'type', 'Client.displayName', 'Contrat.no', 'montant_total', 'frais_ajustement', 'paiement_statut', 'cancel']
        this.table.options.sortable = ['id', 'periode', 'type', 'Client.displayName', 'Contrat.no', 'montant_total', 'paiement_statut']
        this.table.options.filterable = ['id', 'periode', 'type', 'Client.displayName', 'Contrat.no', 'montant_total', 'paiement_statut']
      }
    },

    methods: {
      showEditFacture (type, paiementId, lot) {
        // Si carte de crédit et payer, on affiche pas le bouton edit
        if (type === 2 && paiementId) return false
        // Si ubr et payer, on affiche pas le bouton edit
        if (type === 1 && lot) return false
        return true
      },
      async search () {
        if (this.submit.length === 0) return
        // Start Spinner
        this.$loading.show()
        try {
          // Reset table
          this.tableData = []

          const tableData = await FacturesService.search(this.submit)
          this.tableData = tableData.map(item => {
            if (item.Client) item.Client.displayName = `${item.Client.prenom} ${item.Client.nom} [ ${item.Client.id} ]`
            item.frais_ajustement = item.frais_ajustement ? `${item.frais_ajustement.toFixed(2)} $` : '0 $'
            item.montant_total = item.montant_total ? `${item.montant_total.toFixed(2)} $` : '0 $'
            return item
          })

          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      editView (factureId, type, edit) {
        // Start Spinner
        this.$loading.show()
        // Show dialog
        this.dialogEdit = true

        this.typeEdit = type

        this.factureId = factureId

        this.edit = edit

        this.$nextTick(() => {
          this.$refs.factureMensuelleEdit.resetSubmitForm(factureId)
        })
      },
      async cancel (id) {
        Swal.fire({
          title: 'Attention',
          text: `${this.$i18n.t('contract.swal.text.Change_bill_status')} [${id}]`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$i18n.t('Yes'),
          cancelButtonText: this.$i18n.t('No'),
        }).then(async (result) => {
          if (result.isConfirmed) {
            // Start Spinner
            this.$loading.show()
            try {
              await FacturesService.update({ statut: -1 }, id)
              // Update facture
              const findIndex = this.tableData.findIndex(x => x.id === id)
              this.tableData[findIndex].statut = -1
              // Stop Spinner
              this.$loading.hide()
            } catch (error) {
              console.log(error)
              // Stop Spinner
              this.$loading.hide()
            }
          }
        })
      },
      async getRefund (factureId) {
        // Start Spinner
        this.$loading.show()
        try {
          // On récupère le montant que l'on peut rembourser
          const submitRefund = await FacturesService.getRefund(factureId)
          // Id de facture
          this.factureId = factureId
          this.dialogRefund = true

          this.$nextTick(() => {
            this.$refs.factureRefundDialog.resetSubmitForm(submitRefund)
          })

          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      async getListTransactions (factureId) {
        // Start Spinner
        this.$loading.show()
        try {
          this.dataTransactions = await StripeChargeService.queryByFactureId(factureId)

          this.factureId = factureId
          // Show dialog
          this.dialogPaiementList = true
          // Stop Spinner
          this.$loading.hide()
        } catch (error) {
          console.log(error)
          // Stop Spinner
          this.$loading.hide()
        }
      },
      updateListTransactions () {
        // Reset des transactions
        this.getListTransactions(this.factureId)
        // Reset des factures
        this.search()
      },
      closeDialog () {
        // Hide dialog
        this.dialogEdit = false
        this.dialogRefund = false
        this.dialogPaiementList = false

        // Update la table
        this.search()
      },
    },
  }
</script>
